export default "__VITE_ASSET__9a312f83__"